// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "caption[data-v-1ad607b4] {\n  font-size:0;\n  text-indent:-9999px;\n}\nth[data-v-1ad607b4], td[data-v-1ad607b4] {\n  white-space:nowrap;\n  border-right-width:1px;\n  --tw-border-opacity:1;\n  border-color:rgba(75, 85, 99, var(--tw-border-opacity));\n  padding-left:0.75rem;\n  padding-right:0.75rem;\n  padding-top:0.25rem;\n  padding-bottom:0.25rem;\n  text-align:center;\n  font-size:0.75rem;\n  line-height:1rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
